import { render, staticRenderFns } from "../../assets/templates/StartPlataformas/CommercePage.html?vue&type=template&id=063ff460&scoped=true&"
import script from "../../assets/scripts/StartPlataformas/CommercePage.js?vue&type=script&lang=js&"
export * from "../../assets/scripts/StartPlataformas/CommercePage.js?vue&type=script&lang=js&"
import style0 from "../../assets/scss/commercePage.scss?vue&type=style&index=0&id=063ff460&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063ff460",
  null
  
)

export default component.exports